import { ArrowRight } from 'almanac-ui/icons'
import { Tone } from 'components/DocRightRail/screens/AIAssistant/ToneSelect'
import { Formik } from 'formik'
import { AlmanacFile } from 'types'
import { Form } from '../Form/Form'
import { BlogPostLength } from './Types'
import { filename } from '../schemas/shared/filename'
import { Button } from 'blaze-ui/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { FormSchema } from 'components/Wizards/Wizard/Form/Types'
import { object } from 'yup'
import { project } from 'components/Wizards/schemas/shared/project'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { Sections } from 'components/Wizards/Wizard/Form/Sections'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import {
  ConditionalLanguageInputField as LanguageInputField,
  ConditionalInlineLanguageInputField as InlineLanguageInputField,
} from '../Wizard/Form/LanguageInputField/ConditionalLanguageInputField'

export type Values = {
  topic: string
  goal: string
  audience: string
  blog_length: BlogPostLength
  seo_words: Array<string>
  call_to_action: string
  author_persona: string
  product_description: string
  avoid: string
  additional_info: string
  brand_voice_id?: number
  tone: Array<Tone>
  include_images: boolean
  promotion?: string
  language?: string
  project?: AlmanacFile
  filename: string
  source_materials?: number[]
}

interface Props {
  values: Values
  onSubmit: (values: Values) => void
  seasonalPromotion?: string
  articleId?: string
  schema: FormSchema
}

export const StepOne = ({ onSubmit, values, seasonalPromotion, articleId, schema }: Props) => {
  const isCreatingNewFile = !articleId
  const { isMobile } = useResponsiveDesign()

  if (isCreatingNewFile)
    schema = schema.concat(object({ filename, project })) as FormSchema<ChannelType | GenerationType>

  return (
    <Formik initialValues={values} validationSchema={schema} onSubmit={onSubmit}>
      {({ submitForm }) => (
        <Form.Root>
          <Sections.Root schema={schema}>
            <Sections.ManualFieldsSection />
            <Sections.AutoFillFieldsSection>
              <ResponsiveDesign.Mobile>
                <LanguageInputField />
              </ResponsiveDesign.Mobile>
            </Sections.AutoFillFieldsSection>
            <Form.Actions isSticky>
              <Form.PrimaryActions>
                <ResponsiveDesign.Desktop>
                  <InlineLanguageInputField />
                </ResponsiveDesign.Desktop>
                <Button size="lg" onPress={() => submitForm()} endIcon={ArrowRight} fullWidth={isMobile}>
                  Generate Titles
                </Button>
              </Form.PrimaryActions>
            </Form.Actions>
          </Sections.Root>
        </Form.Root>
      )}
    </Formik>
  )
}
